import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsMblList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsMasterListItem} from '../../../fms.data/models/AmsMasterListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import IfmsModal from '../../../ui/IfmsModal';
import ViewMbl from './implementation/ViewMbl';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';

import BlackInverseButton from '../../../ui/BlackInverseButton';

import mblAll from '../../../img/DownloadAll.png';
import mblNotDown from '../../../img/NotDownloaded.png';
import mblDown from '../../../img/Downloaded.png';
import ApplicationContext from '../../../ApplicationContext';
import { ListFilterType } from '../../../fms.core/constants';
import { useHistory } from 'react-router';
import { openNewPage, NavigationType } from '../../../util/navigationHelpers';
import useReportViewer from '../../../hooks/useReportViewer';
import { AmsHistoryMasterArgs, AmsManifestArgs } from '../../../fms.report/args';
import { DocumentType } from '../../../framework.core/DocumentType';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';

function useMblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(mbl:AmsMasterListItem|null) {
    if (!mbl) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSH/ams', 
      'mblNo', 'MBL #', mbl.mblNo, 'update', false, true,null, null, null, false, true);
    openNewPage(history, `/common/joblistview/AMSH/ams`, NavigationType.newPage);
  }

  function switchToVoyageFor(mbl:AmsMasterListItem|null) {
    if (!mbl) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSV/ams', 
      'id', 'AMS ID', mbl.amsVoyageId, 'update', false, true,null, null, null, false, true);
    openNewPage(history, `/common/joblistview/AMSV/ams`, NavigationType.newPage);
  }


  function switchToMblFor(mbl:AmsMasterListItem|null) {
    if (!mbl) {
      return;
    }
    jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport', 
    'refNo', 'Ref', mbl.mblNo, 'update', false, true,null, null, null, false, true);
    openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  }

  return { switchToHblFor, switchToVoyageFor, switchToMblFor };
}

function useSelectedMblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const { switchToHblFor, switchToVoyageFor, switchToMblFor } = useMblOperations();

  const selectedElement = jobListContext.selectedElement as AmsMasterListItem|null;

  function view() {
    jobListContext.showPopupRow();
  }

  function switchToAmsHbl() {
    const selectedElement = jobListContext.selectedElement as AmsMasterListItem;
    switchToHblFor(selectedElement);
  }

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as AmsMasterListItem;
    switchToMblFor(selectedElement);
  }

  function switchToAmsVoyage() {
    const selectedElement = jobListContext.selectedElement as AmsMasterListItem;
    switchToVoyageFor(selectedElement);
  }

  return { selectedElement,view,  switchToMbl, switchToAmsVoyage, switchToAmsHbl };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { view, switchToMbl, switchToAmsVoyage, switchToAmsHbl } = useSelectedMblOperations();
  const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as OceanQuoteListItem;
  // const appContext = useContext(ApplicationContext);
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  const items = [
    { label: 'View', shortcut: 'F9', separator: true },
    { label: 'Go to AMS Voyage List', shortcut: 'F4', separator: false },
    { label: 'Go to MBL List', shortcut: 'Shift+F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        switchToAmsVoyage();
        break;
      case 2:
        switchToMbl();
        break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      case 4:
        switchToAmsHbl();
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  const {viewReport} = useReportViewer(); 
  const { selectedElement } = useSelectedMblOperations();
  const [ showGlobalYesNoDialog ] = useGlobalYesNoDialog();
  const [view, showView] = useState(false);
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const [listFilter, setListFilter] = useState('A');
  const history = useHistory();

  async function block(isBlock: boolean) {
    const doBlock = await showGlobalYesNoDialog(<p style={{ fontWeight: 'bold', fontSize: '13px' }}>Are you sure you want to {(isBlock ? "Block" : "Cancel block")}?</p>,false, 0, true)

    if (doBlock) {
      const id = selectedElement?.id;

      await appContext.api.block(JobNames.AMSMaster, id, isBlock);

      jobListContext.reloadData();
    } else {
      return;
    }
  }
  function dismissView() {
    showView(false);
    jobListContext.dismissPopupRow();
  }

  async function changeMblListData(type: string) {
    setListFilter(type);
    const listFilterType = type === 'A' ? ListFilterType.All : (type === 'D' ? ListFilterType.Downloaded : ListFilterType.Virgin);
    const apiResult = await appContext.api.getListItems(JobNames.AMSMaster,
      'AmsMasterListItem',
      AmsMasterListItem.calculateSearchParameters(jobListContext.search, AmsMasterListItem.MapSearchFields),
      1,
      jobListContext.search.pageSize, 'AMS', listFilterType);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      jobListContext.setData && jobListContext.setData(AmsMasterListItem.formatData([]),0);
    } else
    jobListContext.setData && jobListContext.setData(AmsMasterListItem.formatData(apiResult.entities), apiResult.totalCount);
  }

  async function openMasterHistoryReport() {
    if(!selectedElement?.id) return;
    const title = "Ams Master BL # " + selectedElement?.mblNo;
    const args = new AmsHistoryMasterArgs({
      docType: DocumentType.AmsHistoryMaster,
      formCaption: title,
      subject: title,

      dataCompanyID: 0,
      masterID: Number(selectedElement?.id),
      amsMode: 'AMS'
    })
    viewReport(args, "", true);
  }

  async function openAmsManifestReport() {
    if(!selectedElement?.id) return;

    const title = "Ams Master Manifest";
    const args = new AmsManifestArgs({
      docType: DocumentType.AmsManifest,
      formCaption: title,
      subject: title,

      amsVoyageId: Number(selectedElement.amsVoyageId),
      amsMasterId: Number(selectedElement?.id),
      amsMode: 'AMS'
    })
    viewReport(args, "", true);
  }

  async function viewDownloadView() {
    if (!selectedElement) {
      return;
    } 

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/download/${JobNames.AMSMaster}/${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function handleAmsFiling() {
    try {
      const isAmsEnable = appContext.suntekSettings?.compliance?.amsEnable;
      const apiResult = await appContext.api.getAmsLink();
      
      if (apiResult && apiResult.success) {
        if (isAmsEnable) {
          window.open('https://ams1.suntekscm.com/login_auto.aspx?' + apiResult.result);
        } else {
          window.open('https://ams1.suntekscm.com/login_2017.aspx');  
        }
      } 
    } catch (error) {
      console.error('AMS Filing Error:', error);
    }
  };

  const allIconSelected = <img height="20px" width='20px' src={mblAll} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const allIcon = <img height="20px" width='20px' src={mblAll} style={{ position: 'relative' }} alt='' />
  const downloadedIconSelected = <img height="20px" width='20px' src={mblDown} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const downloadedIcon = <img height="20px" width='20px' src={mblDown} style={{ position: 'relative'}} alt='' />
  const notDownIconSelected = <img height="20px" width='20px' src={mblNotDown} style={{ position: 'relative', filter: 'grayscale(100%) opacity(50%)' }} alt='' />
  const notDownIcon = <img height="20px" width='20px' src={mblNotDown} style={{ position: 'relative' }} alt='' />

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => showView(true)}
          name='amsMbl-list-view-button'
        >
            View
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(true)}
        >
            Block
        </PrimaryButton>&nbsp;

        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => block(false)}
        >
          Cancel Block
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => viewDownloadView()}
        >
          Download to OI
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => openMasterHistoryReport()}
        >
          AMS Master History
        </PrimaryButton>&nbsp;
        {/* <PrimaryButton
          size="regular"
          disabled={!selectedElement}
          onClick={() => openAmsManifestReport()}
        >
          AMS Manifest
        </PrimaryButton>&nbsp; */}
        <PrimaryButton
          name='ifs-list-amsFiling-button'
          size='regular'
          onClick={handleAmsFiling}
        >
          AMS Filing
        </PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}> 
        <BlackInverseButton
          size='small'
          data-tooltip="All"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'A'}
          onClick={async () => {
            await changeMblListData('A')
          }}>{listFilter === 'A'? allIconSelected : allIcon}
        </BlackInverseButton>&nbsp;
        <BlackInverseButton
          size='small'
          data-tooltip="Downloaded"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'D'}
          onClick={async () => {
            await changeMblListData('D')
          }}>{listFilter === 'D'? downloadedIconSelected :downloadedIcon}
        </BlackInverseButton>&nbsp;
        <BlackInverseButton
          size='small'
          data-tooltip="Not Downloaded"
          notsetbackcolorwhendisabled={'true'}
          disabled={listFilter === 'N'}
          onClick={async () => {
            await changeMblListData('N')
          }}>{listFilter === 'N'? notDownIconSelected :notDownIcon}
        </BlackInverseButton>&nbsp;
      </div>
      <IfmsModal isBlueHeader onCancel={dismissView} draggable isOpen={view || !!jobListContext.viewPopupRow} title="View MBL" width="760px">
        <ViewMbl onPopupClose={dismissView} selectedElementId={selectedElement?.id ?? ''} />
      </IfmsModal>
    </div>
  );
}

function ViListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<AmsMasterListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});
  const { view, switchToMbl, switchToAmsVoyage, switchToAmsHbl } = useSelectedMblOperations();

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToAmsHbl();
    } else if (unprocessedFkey === "F4") {
      switchToAmsVoyage();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToMbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F9") {
      view();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F4', 'SHIFT+F4', 'F6', 'F8', 'F9', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

/**
 * Concrete implementation for AMS MBL List screen
 *
 * @class MblListView
 * @extends {AbstractListView}
 */
 class MblListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, opType :any): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSMaster, 'AmsMasterListItem',
    AmsMasterListItem.calculateSearchParameters(search,AmsMasterListItem.MapSearchFields),
      1,
      search.pageSize,
      'AMS');

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return AmsMasterListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'block', changedValue: (value: any)=> { return nullableCheckBoxValue(value['block'])}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = amsMblList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = AmsMasterListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    
    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  hasViewPopup(): boolean {
    return true;
  }

  getListViewTitle() {
    return `AMS MBL List`;
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  hasMemo(): boolean {
    return false;
  }
};

export default MblListView;
